import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transact_campus_card_account_type.js";
//#region src/transact_campus_card_account_type_helper.ts
var transact_campus_card_account_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(accountType) {
	switch (accountType) {
		case "stored-value": return "Stored Value";
		case "meal-plan": return "Meal Plan";
		case "cash-equivalency": return "Cash Equivalency";
	}
}
//#endregion
export { name, transact_campus_card_account_type_helper_exports };

//# sourceMappingURL=transact_campus_card_account_type_helper.js.map